// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ChecksBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m19.051 11.07-11.2 11a1.5 1.5 0 0 1-2.102 0l-4.8-4.714a1.5 1.5 0 1 1 2.102-2.141l3.75 3.683L16.95 8.93a1.5 1.5 0 1 1 2.102 2.14ZM31.07 8.945a1.502 1.502 0 0 0-2.125-.019L18.8 18.898l-.985-.968a1.5 1.5 0 0 0-2.103 2.14l2.037 2a1.5 1.5 0 0 0 2.102 0l11.2-11a1.501 1.501 0 0 0 .019-2.121v-.004Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
